import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

/** Custom pipe for HTML tag conversion for Terms Of Service content that is fetched from core.
 * Transforms < h3 > to < h2 > and
 * < p class= "title-center" > to <h1>,
 * ensuring sanitized HTML for secure rendering.
 */

@Pipe({
  name: "tagConversion",
})
export class TagConversionPipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer,
  ) {
  }

  transform(value: string): SafeHtml {
    if (value) {
      // Replacing <h3> with <h2>
      value = value.replace(/<h3\b[^>]*>([\s\S]*?)<\/h3>/gi, "<h2>$1</h2>");

      // Changing <p class="title-center"> to <h1>
      value = value.replace(/<p class="title-center">([\s\S]*?)<\/p>/gi, "<h1 class=\"title-center\">$1</h1>");

      // Sanitizing the transformed HTML.
      return this.sanitizer.bypassSecurityTrustHtml(value);
    }
  }

}
